export default __webpack_public_path__ + "static/AppLocation4-38c5ddea1bf6bd822c474d448f06340c.png";